import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Card from "../Base/Card/Card";

const props = {
    onClick: PropTypes.func,
    icon: PropTypes.element.isRequired,
    text: PropTypes.string.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    iconClassName: PropTypes.string,
    iconColor: PropTypes.string,
    width: PropTypes.number,
    userGuideStep: PropTypes.string,
};

const ActionButton = ({ className, disabled, onClick, icon, iconClassName, iconColor, text, width, userGuideStep }) => {
    return (
        <Wrapper
            className={`${className || ""} ${disabled ? "disabled" : ""}`}
            width={width}
            user-guide-step={userGuideStep || ""}
            onClick={() => {
                if (!disabled && onClick) {
                    onClick();
                }
            }}
        >
            <div className={`icon ${iconClassName || ""}`} style={iconColor ? { color: iconColor } : {}}>
                {icon}
            </div>
            <div className="text">{text}</div>
        </Wrapper>
    );
};

const Wrapper = styled(Card)`
    min-width: ${(props) => props.width || 90}px;
    min-height: 90px;
    width: ${(props) => props.width || 90}px;

    margin-right: 6px;

    .card-content {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        cursor: pointer;

        .icon {
            height: 27px;

            display: flex;
            justify-content: center;
            align-items: center;

            font-size: 25px;
            margin-bottom: 5px;

            transition: transform 0.1s;

            img {
                height: 27px;
            }
        }

        .text {
            text-align: center;
            line-height: 16px;
        }

        &:hover {
            .icon {
                transform: scale(1.2);
            }
        }

        @media (max-width: 450px) {
            .text {
                font-size: 11px;
            }
        }
    }

    &.disabled {
        opacity: 0.5;

        .card-content {
            cursor: not-allowed;

            &:hover {
                .icon {
                    transform: none;
                }
            }
        }
    }
`;

ActionButton.propTypes = props;

export default ActionButton;
